/* Peyora bundle picker v2 — config comes from the product metafield custom.bundle_config
   Shape: {"size":3,"title":"...","groups":[{"label":"...","note":"...","min":0,"max":2,"handles":["..."]}]} */
(function () {
  function init(root) {
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    var cfg;
    try { cfg = JSON.parse(root.getAttribute('data-config') || 'null'); } catch (e) { cfg = null; }
    if (!cfg || !cfg.groups || !cfg.groups.length) { root.style.display = 'none'; return; }

    var size = parseInt(cfg.size, 10) || 3;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    var css = '' +
      '.pyb{width:100%;color:#444;font-family:inherit;margin:8px 0 4px}' +
      '.pyb-head{display:flex;justify-content:space-between;align-items:center;gap:12px;margin-bottom:18px}' +
      '.pyb-head h3{margin:0;color:#bd747e;font-size:17px;font-weight:600}' +
      '.pyb-count{flex-shrink:0;border:1px solid #efc6c7;background:#fff8f7;color:#bd747e;border-radius:30px;padding:9px 14px;font-size:13px}' +
      '.pyb-cat{display:flex;justify-content:space-between;align-items:baseline;gap:8px;margin:18px 0 10px}' +
      '.pyb-cat p{margin:0;color:#999;font-size:13px;font-weight:600;letter-spacing:.5px;text-transform:uppercase}' +
      '.pyb-cat span{color:#bd747e;font-size:12px}' +
      '.pyb-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px}' +
      '.pyb-card{min-width:0;overflow:hidden;border:1px solid #efd4d4;border-radius:12px;text-align:center;background:#fff;transition:border-color .2s,box-shadow .2s}' +
      '.pyb-card.is-selected{border:2px solid #c67e87;box-shadow:0 0 0 2px #f9e9e9}' +
      '.pyb-card.is-off{opacity:.45}' +
      '.pyb-img{width:100%;aspect-ratio:1/1;background:#f8eeea}' +
      '.pyb-img img{display:block;width:100%;height:100%;object-fit:contain}' +
      '.pyb-name{min-height:38px;display:flex;justify-content:center;align-items:center;margin:0;padding:5px 3px 0;font-size:13px;line-height:1.3;overflow-wrap:anywhere}' +
      '.pyb-qty{display:flex;align-items:center;justify-content:center;gap:12px;padding:7px 2px 11px}' +
      '.pyb-qty button{width:32px;height:32px;min-width:32px;padding:0;border:1px solid #d98c94;border-radius:50%;background:#fff;color:#c77e87;font-size:20px;line-height:1;cursor:pointer}' +
      '.pyb-qty button:disabled{opacity:.35;cursor:not-allowed}' +
      '.pyb-qty span{min-width:10px;color:#c77e87;font-weight:600;font-size:15px}' +
      '.pyb-msg{margin:15px 0;font-size:13px;color:#bd747e}' +
      '@media (max-width:480px){.pyb-grid{gap:7px}.pyb-name{font-size:11px;min-height:34px}.pyb-qty{gap:7px}' +
      '.pyb-qty button{width:28px;height:28px;min-width:28px}.pyb-head h3{font-size:14px}.pyb-count{padding:8px;font-size:11px}}';
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    root.classList.add('pyb');
    root.innerHTML =
      '<div class="pyb-head"><h3></h3><span class="pyb-count"></span></div>' +
      '<div class="pyb-groups"></div>' +
      '<p class="pyb-msg" aria-live="polite"></p>';
    root.querySelector('h3').textContent = cfg.title || ('Choose Any ' + size);
    var counter = root.querySelector('.pyb-count');
    var message = root.querySelector('.pyb-msg');
    var groupsEl = root.querySelector('.pyb-groups');

    var groups = cfg.groups.map(function (g) {
      return {
        label: g.label || '',
        note: g.note || '',
        min: parseInt(g.min, 10) || 0,
        max: (g.max === undefined || g.max === null) ? size : parseInt(g.max, 10),
        items: []
      };
    });

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text !== undefined) n.textContent = text;
      return n;
    }

    function groupTotal(g) {
      return g.items.reduce(function (s, it) { return s + it.qty; }, 0);
    }
    function total() {
      return groups.reduce(function (s, g) { return s + groupTotal(g); }, 0);
    }

    function selected() {
      var out = [];
      groups.forEach(function (g) {
        g.items.forEach(function (it) {
          for (var i = 0; i < it.qty; i++) out.push(it.title);
        });
      });
      return out;
    }

    function problem() {
      var t = total();
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i], gt = groupTotal(g);
        if (gt < g.min) return 'Please choose ' + (g.min - gt) + ' more from ' + g.label + '.';
        if (gt > g.max) return 'You can choose up to ' + g.max + ' from ' + g.label + '.';
      }
      if (t < size) return 'Select ' + (size - t) + ' more product' + (size - t === 1 ? '' : 's') + ' to continue.';
      if (t > size) return 'Please select exactly ' + size + ' products.';
      return '';
    }

    function getForm() {
      var scope = root.closest('.shopify-section, product-info, .product') || document;
      var forms = Array.prototype.filter.call(
        scope.querySelectorAll('form[action*="/cart/add"]'),
        function (f) { return !root.contains(f); }
      );
      return forms.filter(function (f) { return f.querySelector('[name="id"]') && f.querySelector('[name="quantity"]'); })[0] ||
        forms.filter(function (f) { return f.querySelector('[name="id"]'); })[0] || forms[0] || null;
    }

    function sync() {
      var form = getForm();
      if (!form) return false;
      var picks = selected();
      var props = { 'Selected Shades': picks.join(', ') };
      for (var i = 0; i < size; i++) props['Shade ' + (i + 1)] = picks[i] || '';
      Object.keys(props).forEach(function (name) {
        var input = form.querySelector('input[data-peyora-property="' + name + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[' + name + ']';
          input.setAttribute('data-peyora-property', name);
          form.appendChild(input);
        }
        input.value = props[name];
        input.disabled = false;
      });
      return true;
    }

    function update() {
      var t = total();
      groups.forEach(function (g) {
        var gt = groupTotal(g);
        g.items.forEach(function (it) {
          it.qtyEl.textContent = it.qty;
          it.card.classList.toggle('is-selected', it.qty > 0);
          it.plus.disabled = !it.available || t >= size || gt >= g.max;
          it.minus.disabled = it.qty <= 0;
        });
        if (g.noteEl) {
          var txt = '';
          if (g.min && g.min === g.max) txt = 'Choose ' + g.min + ' · ' + gt + '/' + g.min;
          else if (g.max < size) txt = 'Max ' + g.max + ' per box · ' + gt + '/' + g.max;
          g.noteEl.textContent = txt;
        }
      });
      counter.textContent = t + ' / ' + size + ' selected';
      var p = problem();
      message.textContent = p || ('Perfect! Your ' + size + ' products are selected.');
      sync();
    }

    function validate(event) {
      var p = problem();
      if (p) {
        event.preventDefault();
        event.stopImmediatePropagation();
        message.textContent = p;
        if (root.scrollIntoView) root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      if (!sync()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        message.textContent = 'Product form not found. Please refresh and try again.';
        return false;
      }
      return true;
    }

    function fetchProduct(handle) {
      return fetch(base + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }

    var jobs = [];
    cfg.groups.forEach(function (g, gi) {
      (g.handles || []).forEach(function (h, hi) {
        jobs.push(fetchProduct(h).then(function (p) { return { gi: gi, hi: hi, h: h, p: p }; }));
      });
    });

    counter.textContent = '0 / ' + size + ' selected';
    message.textContent = 'Loading shades…';

    Promise.all(jobs).then(function (rows) {
      rows.sort(function (a, b) { return a.gi - b.gi || a.hi - b.hi; });
      rows.forEach(function (r) {
        if (!r.p) return;
        var img = r.p.featured_image || '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
        groups[r.gi].items.push({ handle: r.h, title: r.p.title, img: img, available: r.p.available !== false, qty: 0 });
      });

      groups.forEach(function (g) {
        if (!g.items.length) return;
        var head = el('div', 'pyb-cat');
        head.appendChild(el('p', '', g.label));
        g.noteEl = el('span', '');
        head.appendChild(g.noteEl);
        groupsEl.appendChild(head);
        var grid = el('div', 'pyb-grid');
        g.items.forEach(function (it) {
          var card = el('div', 'pyb-card' + (it.available ? '' : ' is-off'));
          card.setAttribute('data-handle', it.handle);
          var box = el('div', 'pyb-img');
          if (it.img) {
            var im = document.createElement('img');
            im.src = it.img; im.alt = it.title; im.loading = 'lazy'; im.width = 400; im.height = 400;
            box.appendChild(im);
          }
          card.appendChild(box);
          card.appendChild(el('p', 'pyb-name', it.available ? it.title : it.title + ' (sold out)'));
          var q = el('div', 'pyb-qty');
          it.minus = el('button', '', '−'); it.minus.type = 'button';
          it.minus.setAttribute('aria-label', 'Remove one ' + it.title);
          it.qtyEl = el('span', '', '0');
          it.plus = el('button', '', '+'); it.plus.type = 'button';
          it.plus.setAttribute('aria-label', 'Add one ' + it.title);
          q.appendChild(it.minus); q.appendChild(it.qtyEl); q.appendChild(it.plus);
          card.appendChild(q);
          it.card = card;
          it.plus.addEventListener('click', function () {
            if (!it.plus.disabled) { it.qty++; update(); }
          });
          it.minus.addEventListener('click', function () {
            if (it.qty > 0) { it.qty--; update(); }
          });
          grid.appendChild(card);
        });
        groupsEl.appendChild(grid);
      });
      update();
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]') || root.contains(form)) return;
      validate(event);
    }, true);

    document.addEventListener('click', function (event) {
      var t = event.target;
      if (!(t instanceof Element)) return;
      var btn = t.closest('button[name="add"], button[name="buy"], .shopify-payment-button__button, [data-fastrr], .fastrr-buy-now, .peyora-buy-now, [id^="BuyNowButton"]');
      if (!btn || root.contains(btn)) return;
      var form = btn.form || btn.closest('form') || getForm();
      if (!form || root.contains(form)) return;
      validate(event);
    }, true);

    document.addEventListener('change', function (event) {
      if (event.target instanceof Element && event.target.closest('form[action*="/cart/add"]')) sync();
    }, true);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-peyora-bundle]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
